import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0 }) => (
  <span className="mask-line">
    <motion.span
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const ParallaxFloat = ({ src, className = "", speed = 60, rotate = 10 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [speed, -speed]);
  const r = useTransform(scrollYProgress, [0, 1], [-rotate, rotate]);
  return <motion.img ref={ref} src={src} alt="" aria-hidden="true" className={`parallax-float ${className}`} style={{ y, rotate: r }}/>;
};

export const Marquee = ({ items }) => (
  <div className="marquee" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map(copy => (
        <div className="marquee-group" key={copy} aria-hidden={copy === 1}>
          {items.map((t, i) => <span key={i}>{t}<i/></span>)}
        </div>
      ))}
    </div>
  </div>
);


const LEAF_PATHS = [
  <g key="leaf"><path d="M50 6C78 28 84 62 50 94 16 62 22 28 50 6Z"/><path d="M50 14V88"/><path d="M50 32 34 46M50 32l16 14M50 54 32 70M50 54l18 16"/></g>,
  <g key="sprig"><path d="M50 96C50 62 50 32 50 8"/><path d="M50 78C34 74 24 62 22 46c16 4 26 16 28 32Z"/><path d="M50 78c16-4 26-16 28-32-16 4-26 16-28 32Z"/><path d="M50 48C38 44 30 34 28 22c12 4 20 14 22 26Z"/><path d="M50 48c12-4 20-14 22-26-12 4-20 14-22 26Z"/><path d="M50 22c-5-6-5-12 0-18 5 6 5 12 0 18Z"/></g>,
  <g key="grass"><path d="M20 96C22 60 30 30 44 10"/><path d="M50 96C50 58 54 28 62 6"/><path d="M80 96C76 62 70 36 58 18"/></g>,
];

export const BotanicalFloat = ({ className = "", speed = 70, rotate = 14, variant = 0 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [speed, -speed]);
  const r = useTransform(scrollYProgress, [0, 1], [-rotate, rotate]);
  return (
    <motion.svg ref={ref} viewBox="0 0 100 100" aria-hidden="true" className={`botanical-float ${className}`} style={{ y, rotate: r }}>
      {LEAF_PATHS[variant % LEAF_PATHS.length]}
    </motion.svg>
  );
};